import React from "react";
import {DefaultLoader} from "../DefaultLoader";



export const EnigooLoader = ({text = "Načítám data..."}) => {

    return <DefaultLoader text={text}/>
}
